import regUtils from 'utils/regUtils';
import * as yup from 'yup';

const { PHONE_REGEX } = regUtils;

export interface CommentApi {
  code: string;
  commentID: number;
  commenter: {
    customerID?: number;
    employeeID?: number;
    fullname: string;
    email: string;
    isModerator: boolean;
  };
  content: string;
  createdTime: string;
  fullname: string;
  isApproved: boolean;
  replies: CommentApi[];
  status: 'REPLIED' | 'COMMENT';
  targetCode: string;
  targetType: string;
  totalReplies?: number;
  parentCommentID?: number;
  type: string;
}

export interface QAValues {
  fullName: string;
  numberPhone: string;
  businessType?: {
    key: string;
    value: string;
  };
  province?: any;
  question: string;
}

export const defaultValues: QAValues = {
  fullName: '',
  numberPhone: '',
  businessType: {
    key: '',
    value: '',
  },
  province: {
    label: '',
    regionCode: '',
    value: '',
  },
  question: '',
};

export const schema = yup.object({
  question: yup.string().trim().min(3, 'Tối thiểu 3 ký tự').required('Thông tin bắt buộc'),
});

export const schemaReply = yup.object({
  reply: yup.string().trim().min(3, 'Tối thiểu 3 ký tự').required('Thông tin bắt buộc'),
});

export const schemaNotLogin = yup.object({
  fullName: yup.string().trim().required('Vui lòng nhập họ tên').min(2, 'Tên phải dài hơn 2 kí tự'),
  numberPhone: yup.string().test({
    name: 'is-valid-numberPhone',
    test(value, ctx) {
      if (!value) {
        return ctx.createError({ message: 'Vui lòng nhập số điện thoại' });
      }
      if (value.length < 10) return ctx.createError({ message: 'Số điện thoại sai định dạng' });
      if (value.length > 11 && /^(02)/.test(value)) {
        return ctx.createError({ message: 'Số điện thoại không được vượt quá 11 ký tự' });
      }
      if (value.length > 10 && /^(09|07|08|05|03)/.test(value)) {
        return ctx.createError({ message: 'Số điện thoại không được vượt quá 10 ký tự' });
      }
      if (value.length === 10) {
        if (!PHONE_REGEX.test(value)) {
          return ctx.createError({ message: 'Số điện thoại sai định dạng' });
        }
      }
      if (!/^(09|07|08|05|03|02)/.test(value)) {
        return ctx.createError({ message: 'Số điện thoại sai định dạng' });
      }
      return true;
    },
  }),
  businessType: yup.object({
    key: yup.string(),
    value: yup.string(),
  }),
  province: yup.object({
    label: yup.string(),
    regionCode: yup.string(),
    value: yup.string(),
  }),
  question: yup.string().trim().min(3, 'Tối thiểu 3 ký tự').required('Thông tin bắt buộc'),
});

export const defaultData: {
  comments: CommentApi[];
  totalComment: number;
  totalCommentVisible: number;
} = {
  comments: [],
  totalComment: 0,
  totalCommentVisible: 0,
};

export const LIMIT_HEIGHT_COMMENTS = 840;
export const LIMIT_ITEMS = 5;
